<template>
  <div class="Typeahead">    
     <div  v-show="idCompanyClient" class="input-group  input-group input-group-md">
      <span class="input-group-addon">
        <i class="fa fa-user" title="Mitarbeiter"></i> - 
        <i class="fa fa-users" title="Abteilung"></i> - 
        <i class="fa fa-commenting" title="Thema"></i>
      </span>
      <input type="text"
             id="userclient-typeahead"
             class="form-control"
             style="font-family: FontAwesome;"
             placeholder="Mitarbeiter - Abteilung - Thema suchen..."
             autocomplete="off"
             v-model="query"
             @keydown.down="down"
             @keydown.up="up"
             @keyup.enter="hit($event)"
             @keydown.esc="reset"
             @input="update"/>
       <span class="input-group-btn">
        <button class="btn btn-primary" type="button" @click="onClickFindAll">
          <span v-if="query" class="glyphicon glyphicon glyphicon-eye-close" aria-hidden="true"></span>
          <span v-else class="glyphicon glyphicon glyphicon-eye-open" aria-hidden="true"></span>
        </button>
        
        
     
      <button type="button"
        class="btn btn-primary dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        <span class="glyphicon glyphicon-menu-hamburger" aria-hidden="true"></span>
      </button>
      
      <ul style="background-color: #fff" class="dropdown-menu dropdown-menu-right">
        <li><a @click="onClickNew">Mitarbeiter - Abteilung - Thema anlegen</a></li>
      </ul>
      
        
        
      </span>
    </div>

    <div v-show="isDirty && !hasItems && !loading" class="alert alert-warning" role="alert">Kein Mitarbeiter - Abteilung - Thema gefunden
    </div>
    
    <ul v-show="hasItems">
      <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
        <i  class="fa fa-lg" v-bind:class="userClientType[item.idSex].class" :title="userClientType[item.idSex].text"></i>
        <span class="name" v-text="userClientType[item.idSex].sexText"></span> 
        <span class="name" v-html="highlight(item.firstName)"></span> 
        <span class="name" v-html="highlight(item.lastName)"></span>
        <span v-show="item.department">, <i  class="fa fa-users"  title="Abteilung"></i><span class="screen-name" v-html="highlight(item.department)"></span></span>
        <span v-show="item.function">, <i class="fa fa-cogs" title="Funktion"></i><span class="screen-name" v-html="highlight(item.function)"></span></span>
        <span v-show="item.room">, <i class="fa fa-map-marker" title="Zimmer/Ort"></i><span class="screen-name" v-html="highlight(item.room)"></span></span>
        <span v-show="item.template">, <i class="fa fa-file-text" v-bind:title="item.template" ></i></span>
      </li>
    </ul>
  </div>
</template>



<script>
import VueTypeahead from './common/typeahead.common'
import bus from './common/bus'

export default {
  extends: VueTypeahead,

  data () {
    return {
      limit: 20,
      minChars: 1,
      takeFirstItemOnHit: false,
      idCompanyClient: bus.call.idCompanyClient,
      userClientType: {
         '': {class: 'fa-question ', text: 'Unbekannt', sexText: ''},
         0: {class: 'fa-question ', text: 'Unbekannt', sexText: ''},
         1: {class: 'fa-user', text: 'Herr', sexText: 'Herr'},
         2: {class: 'fa-user', text: 'Frau', sexText: 'Frau'},
         3: {class: 'fa-users', text: 'Abteilung', sexText: ''},
         4: {class: 'fa-commenting', text: 'Thema', sexText: ''}
      },
      


    }
  },
  
  created: function () {
    //bus.registerOnLogout(this.reset2);
    bus.registerOnIdCompanyClient(this.onIdCompanyClient)
    bus.registerOnIdUserCaller(this.onIdUserCaller)
    bus.registerOnIdUserClient(this.onIdUserClient)

  },
  
 computed: {
    src: function () {
      return bus.config.path + '/search/userclient/' + this.idCompanyClient;
    },
   
  },
  
  watch: {
    
    
    query: function (val,old) {
      if(val.length && !old.length){
        // wenn eingabe beginnt
        this.$emit('onSearch');
      }
    }
  },
  

  methods: {
    
    onClickNew () {
      this.$emit('onClickNew');
    },
    
    onClickFindAll () {
      this.query = this.query ? '' : '%'
      this.update()
    },
    
    reset2 () {
      this.idCompanyClient = 0;
      this.reset();
    },
    
    
    onHit (item ) {
      this.$emit('onHit', item);
      //bus.emitIdUserClient(item.idUserClient);
      //console.log(this.query);
      this.reset();
      
    },
    
    onHitNew () {
      // Do Nothing
    },

    
    highlight: function(value){
        var query = this.query.substring(0,1) == '%' ? this.query.substring(1) : this.query;
        return value.replace( RegExp("("+query+")","gi"), '<b>$1</b>' );
    },

    onIdCompanyClient: function (idCompanyClient) {
      this.idCompanyClient = idCompanyClient;
    },
    
    onIdUserCaller: function (IdUserCaller) {
      if(IdUserCaller > 0){
        document.getElementById("userclient-typeahead").focus();
      }
    },

    onIdUserClient: function (IdUserClient) {
      console.log('zeige alles ' + IdUserClient);
      if(IdUserClient == 0){
        this.query = '%'
        this.update()
      }else{
        this.query = ''
        this.update()
      }
    },
    
  }
  
}
</script>



<style scoped>
.Typeahead {
 position: relative;
}

.Typeahead__input {
  width: 100%;
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.42857143;
  box-shadow: inset 0 1px 4px rgba(0,0,0,.4);
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  font-weight: 300;
  padding: 12px 26px;
  border: none;
  border-radius: 22px;
  letter-spacing: 1px;
  box-sizing: border-box;
}

.Typeahead__input:focus {
  border-color: #4fc08d;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px #4fc08d;
}
  .alert{
    margin-top: 15px;
  }
  
.fa-times {
  cursor: pointer;
}
  .fa{
        color: #337ab7;
  }
  

  .item-list{

  }  
  
ul .fa{
    padding-right: 5px;
    padding-left: 10px;
  } 
  
ul .fa-lg{
    padding-left: 0px;
  }

ul {
  position: absolute;
  padding: 0;
  margin-top: 8px;
  min-width: 100%;
  background-color: rgb(255, 254, 234);
  list-style: none;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0,0,0, 0.25);
  z-index: 1000;
  overflow: auto;
  max-height: 40vH; 
}

li {
  padding: 8px 16px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

li:first-child {
  border-radius: 4px 4px 0 0;
}

li:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 0;
}

li span{
  color: #2c3e50;
}

.active {
  background-color: #3aa373;
}

.active span {
  color: white;
}

.name {
  font-weight: 400;
  font-size: 18px;
}

.screen-name {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// UserClientTypeahead.vue?3b43fb17